import { FastTooltipShow } from '@components/FastTooltipShow';
import { Skeleton } from '@components/ui/Skeletons/Skeleton';
import { useGetDocumentSiiStatusesQuery } from '@store/skeletor/documents/siiStatuses/getDocumentSiiStatuses';
import { NO_INFORMATION_LABEL } from '@utils/text/commonText';

import { selectByCode } from './selectByCode';
import { type SiiStatusContainerProps } from './types';

const SiiStatusContainer = ({ siiStatusCode }: SiiStatusContainerProps) => {
  const { data, isLoading } = useGetDocumentSiiStatusesQuery(
    {},
    {
      selectFromResult: selectByCode(siiStatusCode),
    },
  );

  if (isLoading) {
    return <Skeleton className="h-6 w-20" />;
  }

  if (data === null) {
    return <span>{NO_INFORMATION_LABEL}</span>;
  }

  return (
    <FastTooltipShow title={data.responseDescription}>
      <span>{data.shortDescription}</span>
    </FastTooltipShow>
  );
};

export { SiiStatusContainer };
